import { useState } from 'react';
import {
    createStyles,
    Paper,
    Title,
    Text,
    TextInput,
    Button,
    Container,
    Group,
    Anchor,
    Center,
    Box,
  } from '@mantine/core';
  import { PasswordStrength } from '../components/PwStrength';
  import { Link, Navigate } from 'react-router-dom';
  import { useMutation } from 'graphql-hooks';
  import { HANDLE_FORGOTPW_MUTATION } from '../network/mutations';
  import { IconArrowLeft } from '@tabler/icons';
  import { useAuth } from '../components/AuthProvider';
  import { useParams } from 'react-router-dom';
  
  const useStyles = createStyles((theme) => ({
    title: {
      fontSize: 26,
      fontWeight: 900,
      fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    },
  
    controls: {
      [theme.fn.smallerThan('xs')]: {
        flexDirection: 'column-reverse',
      },
    },
  
    control: {
      [theme.fn.smallerThan('xs')]: {
        width: '100%',
        textAlign: 'center',
      },
    },
  }));
  
  export function HandleForgotPw(params) {
    const { classes } = useStyles();
    const [ email, setEmail ] = useState('');
    const [ pw, setPw ] = useState('');
    const [ success, setSuccess ] = useState(false);
    const [ forgotPw ] = useMutation(HANDLE_FORGOTPW_MUTATION);
    const { setAuthenticated, setToken } = useAuth();
    const { code } = useParams();
  
    const onSubmit = (evt) => {
        evt.preventDefault();
        if (email === '' || !/@/.test(email)) {
            return false;
        }
        if (pw === '') {
          return false;
        }

        forgotPw({variables: { email, code, newPw: pw }, onSuccess: (data) => {
            const { forgotPw } = data;
            const jwt = forgotPw?.jwt;
            if (jwt) {
              setAuthenticated(true);
              setToken(jwt);
              setSuccess(data.forgotPw); 
              window.location = '/login';
            }
        }});
    }
    const successMsg = <Navigate to="/app/dashboard" />;

    return (
      <Container size={460} my={30}>
        <Title className={classes.title} align="center">
          Reset your password
        </Title>
        <Text c="dimmed" fz="sm" ta="center">
          Enter your email and a new password
        </Text>
  
        <Paper withBorder shadow="md" p={30} radius="md" mt="xl">
          {success ? successMsg : (
          <>
            <TextInput label="Your email" placeholder="you@yourdomain.com" value={email} onChange={evt => setEmail(evt.target.value)} required />
            <PasswordStrength setPassword={setPw} />
            <Group position="apart" mt="lg" className={classes.controls}>
              <Link to="/login" color="dimmed" size="sm" className={classes.control}>
                <Anchor color="dimmed" size="sm" className={classes.control}>
                  <Center inline>
                    <IconArrowLeft size={12} stroke={1.5} />
                    <Box ml={5}>Back to the login page</Box>
                  </Center>
                </Anchor>
              </Link>
              <Button onClick={onSubmit} className={classes.control}>Reset password</Button>
            </Group>
          </>)}
        </Paper>
      </Container>
    );
  }